var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintGIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.168H5V15H15V14.168ZM4.16797 0.832031H11.668V5H15.8359V6.66797H16.668V4.16797L12.5 0H3.33203V6.66797H4.16406V0.832031H4.16797ZM17.5 7.5H2.5C0.832031 7.5 0 8.33203 0 10V15H3.33203V20H16.6641V15H20V10C20 8.33203 19.168 7.5 17.5 7.5ZM3.33203 10.832H1.66797V9.16406H3.33594V10.832H3.33203ZM15.832 19.168H4.16797V13.332H15.8359V19.168H15.832ZM15 15.832H5V16.6641H15V15.832ZM15 17.5H5V18.332H15V17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintGIcon);
export default __webpack_public_path__ + "static/media/PrintGIcon.5c44a4c52babb8688e4bdf98a1bc1e4b.svg";
export { ForwardRef as ReactComponent };